import React, {useEffect, useState} from 'react';
import ExtractsMonitoringChannel from '../../channels/extracts_monitoring_channel';

const useRunExtract = ({extractId, extract, onStart, onStarted}) => {
  const channel = ExtractsMonitoringChannel(extractId);
  const [extractRuning, setExtractRuning] = useState(false);
  channel.received = (data) => {
    setExtractRuning(data.running);
  };
  useEffect(() => {
    if (extract && extract.running) {
      setExtractRuning(true)
    }
  }, [extract])

  const runExtract = () => {
    setExtractRuning(true);
    onStart()
      .finally(() => {
        onStarted();
        setExtractRuning(false);
      });
  }

  return {extractRuning, runExtract}
}

export default useRunExtract